import { browser } from '$app/environment';
import { spineBus } from '$lib/services/gatekeeper/MessageBus';
import { throttle } from 'lodash-es';
import { Duration } from 'luxon';

const MAX_TICK_RATE_SECS = Duration.fromObject({ seconds: 60 });

export class TokenRefreshTickGenerator {
    private hasRunCallbacks = false;
    private callbacks: (() => Promise<void>)[] = [];
    constructor() {
        if (!browser) {
            throw Error('Only supported in the browser');
        }
        document.addEventListener('touchstart', this.runCallbacks);
        document.addEventListener('mousemove', this.runCallbacks);
        document.addEventListener('scroll', this.runCallbacks);
        document.addEventListener('keydown', this.runCallbacks);
        // TODO: Update types
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        spineBus.subscribe('external', (payload: any) => {
            if (payload.kind == 'wallet-balance-updated' && payload.source == 'gameplay') {
                this.runCallbacks();
            }
        });
    }
    private runCallbacks = throttle(async () => {
        if (this.hasRunCallbacks) {
            await Promise.all(this.callbacks.map(async (callback) => await callback()));
        }
        this.hasRunCallbacks = true;
    }, MAX_TICK_RATE_SECS.toMillis());
    onTick = (callback: () => Promise<void>) => this.callbacks.push(callback);
    static onTick = (callback: () => Promise<void>) =>
        new TokenRefreshTickGenerator().onTick(callback);
}
